import { featuredCards } from '@/mocks/home';
import Reveal from '@/pages/home/components/Reveal';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function FeaturedCards() {
  return (
    <section id="featured" className="py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <SectionHeading
              eyebrow="大图精选"
              icon="ri-image-2-line"
              title="封面驱动，一眼看清是哪一类的料"
              desc="精选内容以封面优先的大图卡片排列，卡片顶部直接给出栏目归属，先看画面再决定要不要深入，翻起来比纯列表更快。"
            />
            <a
              href="#tags"
              className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              按标签继续筛
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </Reveal>

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {featuredCards.map((card, index) => (
            <Reveal key={card.id} delay={index * 50}>
              <article className="card-hover group h-full overflow-hidden rounded-lg border border-background-200 bg-background-50 hover:border-primary-300">
                <div className="relative h-48 w-full overflow-hidden sm:h-52">
                  <img
                    src={card.cover}
                    alt={`${card.title} - 黑料网1 ${card.category}`}
                    title={`${card.title} - 黑料网1 ${card.category}栏目`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/95 px-2.5 py-1 text-[11px] font-medium text-primary-700">
                    <i className="ri-folder-3-line text-xs"></i>
                    {card.category}
                  </span>
                </div>
                <div className="flex flex-col p-5">
                  <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950">
                    {card.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{card.summary}</p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1.5">
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-calendar-line text-sm"></i>
                      </span>
                      {card.date}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-eye-line text-sm"></i>
                      </span>
                      {card.views}
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}